import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import HomeBanner from './HomeBanner';
import HomeCategory from './HomeCategory';
import HomeManager from './HomeManager';
import HomeStores from './HomeStores';
import HomeStores2 from './HomeStores2';
import BottomMenu from './BottomMenu';
import SidebarPanel from './SidebarPanel';

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOCATION: this.props.location.pathname,
            LOADING: true, 
            BANNER: [],
            CATEGORY: [],
            HOME_MANAGER: [],
            STORE: [],
            STORE2: [],
            ADDRESS: '',
            cusADDRESS:'',
            CUSTOMER_DET: '',
            LASTORDER: '',
            POPUP: 'N',
            POPUPTITLE: '',
            POPUPIMAGE: '',
            POPUPFREQUENCY: ''
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    fetchHomePage(mode) {

        var id = localStorage.getItem('delCIRCLE');

        let address_id = '';
        if(localStorage.getItem('addressID'))
            address_id = localStorage.getItem('addressID');

        if(address_id==undefined || address_id=='undefined')
            address_id = '';

        let customer = '';
        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');

        if(customer==undefined || customer=='undefined')
            customer = '';
        
        var that = this;
        fetch('https://m.donedelivery.in/api/home_api.php?mode='+mode+'&id='+id+'&address_id='+address_id+'&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            
            var BANNER = result.BANNER;
            var CATEGORY = result.CATEGORY;
            var HOME_MANAGER = result.HOME_MANAGER;
            var STORE = result.STORE;
            var STORE2 = result.STORE2;
            var ADDRESS = result.ADDRESS;
            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
            var LASTORDER_COUNT = result.LASTORDER;

            var POPUP = result.POPUP;
            var POPUPTITLE = result.POPUP_TITLE;
            var POPUPIMAGE = result.POPUP_IMAGE;
            var POPUPFREQUENCY = result.POPUP_FREQUENCY;

            that.setState({ LOADING:false, BANNER:BANNER, CATEGORY:CATEGORY, HOME_MANAGER:HOME_MANAGER, STORE:STORE, STORE2:STORE2, cusADDRESS:ADDRESS, CUSTOMER_DET:CUSTOMER_DET, LASTORDER:LASTORDER_COUNT, POPUP: POPUP, POPUPTITLE:POPUPTITLE, POPUPIMAGE:POPUPIMAGE, POPUPFREQUENCY:POPUPFREQUENCY });

            if(POPUP==='Y')
            {
                if(POPUPFREQUENCY==='X')
                    $('#popupContent').modal('show');
                else
                {
                    let popFREQ = POPUPFREQUENCY.split('~');
                    let f = popFREQ[0];
                    let t = popFREQ[1];

                    let popupDISPLAYED = '';
                    //localStorage.setItem('popData', '');
                    if(localStorage.getItem('popData'))
                        popupDISPLAYED = localStorage.getItem('popData');
                    if(popupDISPLAYED==='' || popupDISPLAYED===undefined || popupDISPLAYED==='undefined')
                    {
                        $('#popupContent').modal('show');
                        let date = new Date();
                        localStorage.setItem('popData', date);
                    }
                    else
                    {
                        let date = new Date();
                        var add_minutes =  function (dt, minutes) {
                            return new Date(dt.getTime() + minutes*60000);
                        }

                        var add_hours =  function (dt, hours) {
                            return new Date(dt.getTime() + hours*60*60000);
                        }

                        let newDATE = '';
                        if(t==='M') newDATE = add_minutes(new Date(popupDISPLAYED), f).toString();
                        else if(t==='H') newDATE = add_hours(new Date(popupDISPLAYED), f).toString();

                        /*console.log('Current Time');
                        console.log(date);
                        console.log('Next Popup Time');
                        console.log(newDATE);*/

                        var compare_dates = function(date1,date2){
                            if (date1>date2) return 'N';
                            else if (date1<date2) return 'Y';
                            else return 'N'; 
                        }

                        let displayPOPUP = compare_dates(new Date(newDATE), new Date(date));
                        //console.log(displayPOPUP);
                        if(displayPOPUP=='Y')
                        {
                            $('#popupContent').modal('show');
                            localStorage.setItem('popData', newDATE);
                        }
                    }
                }
            }
        });
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }
    }

    componentDidMount() {
        this.fetchHomePage('HOME');
    }

    handleSearchClick = () => {
        var a = $("#search").hasClass("show");
        if (a) {
            $("#search").removeClass("show");
        }
        else {
            $("#search").addClass("show");
            $("#search .form-control").focus();
        }        
    };

	handleSubmit(event) {
		event.preventDefault();
		this.setState({ redirect: true });
		this.setState({ search_text: event.target.elements.search.value });

		event.target.elements.search.value = '';
	}

    onKeyDown = (event) => {
        //console.log(event.key);
        var that = this;
        if (event.key === 'Enter')
        {
            event.preventDefault();
            event.stopPropagation();
            event.preventDefault();

            let search_value = $('#search_text').val();
            that.setState({ redirect: true, search_text: search_value });
        }
    }

    render() { 
	 
        if (this.state.redirect)
        {
            this.setState({ redirect: false });
            return <Redirect to={`/search/${this.state.search_text}`} />;
        }

        if(localStorage.getItem('delCIRCLE')==null)
        {
	        return (<Redirect to={'/search'}/>)
        }
        
        let props = {
            offers: this.state.OFFERS,
            items: this.state.MENU,
            sections: this.state.SECTION,
            page: 'HOME'
        };

        let GPS = 'N';
        if(localStorage.getItem('GPS')!==null)
            GPS = localStorage.getItem('GPS');

        let LABEL = '';
        let ADD = '';

        if(this.state.cusADDRESS!='' && GPS=='N')
        {
            let cusADDRESS = this.state.cusADDRESS.split('~~**~~');
            LABEL = cusADDRESS[0];
            ADD = cusADDRESS[1];
            if(cusADDRESS[2]!='')
                ADD += ', '+cusADDRESS[2];
        }
        else
        {
            let cusADDRESS = '';
            if(localStorage.getItem('searchedADDRESS'))
                cusADDRESS = localStorage.getItem('searchedADDRESS');
            
            if(cusADDRESS!='' && cusADDRESS!=undefined && cusADDRESS!='undefined')
            {
                var cusADDRESS = cusADDRESS.split(",");
                LABEL = cusADDRESS.splice(0,1).join("");
                ADD = cusADDRESS.join(",");
            }
        }

        let logged = 'N';
        if(localStorage.getItem('userData'))
            logged = 'Y';
        
        let url = (logged=='Y')?'/search':'/map';

        return (
            <div>
                {this.state.LOADING && <Loader />}
                {this.state.POPUP==='Y' && this.state.POPUPIMAGE!=='' &&
                    <div className="modal fade dialogbox" id="popupContent" data-backdrop="static" tabIndex="-1" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-body"> 
                                    <img src={this.state.POPUPIMAGE} alt={this.state.POPUPTITLE} className="imaged popup-image"/>
                                </div>
                                <div className="modal-footer">
                                    <div className="btn-inline"> 
                                        <button type="button" className="btn" data-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div id="search" className="appHeader">
                    <form className="search-form" onSubmit={this.handleSubmit}>
                        <div className="form-group searchbox">
                            <input type="search" className="form-control" id="search_text" name="search" placeholder="Search..." onKeyDown={this.onKeyDown} minLength="3" />
                            <i className="input-icon">
                                <ion-icon name="search-outline"></ion-icon>
                            </i>
                            <Link to="#" className="ml-1 close toggle-searchbox" onClick={this.handleSearchClick}>
                                <ion-icon name="close-circle"></ion-icon>
                            </Link>
                        </div>
                    </form>
                </div>
                <div className="appHeader bg-dark text-light">
                    <div className="left">
                        <Link to={url} className="headerButton pl-0">
                            <ion-icon name="location-outline"></ion-icon>
                        </Link>
                        <Link to="/home" className="headerButton p-0">
                            <img src="/assets/img/done-logo.png" alt="image" className="form-image" />
                        </Link>
                    </div>
                    <div className="pageTitle title-cut">
                        <div className="title-cut-sub">{LABEL}&nbsp;{ADD}</div>
                    </div>
                    <div className="right">
                        <Link to="#" onClick={this.handleSearchClick} className="headerButton imaged w40 toggle-searchbox">
                            <ion-icon name="search-outline"></ion-icon>
                        </Link>
                        <Link to="#" className="headerButton text-light" data-toggle="modal" data-target="#sidebarPanel">
                            <ion-icon name="menu-outline"></ion-icon>
                        </Link>
                    </div>
                </div>
                <div id="appCapsule" className="mt-1 p-0">
                    {/* banner */}
                    {this.state.BANNER.length>0 && <HomeBanner banners={this.state.BANNER} />}

                    {this.state.LASTORDER>0 && <div className="section inset pt-3 pb-0">
                        <div className="row">
                            <div className="col-6">
                                <div className="card pt-1 pb-1 text-center">
                                    <Link to="/reorder" className="text-upper mb-05 font-size-12 text-danger font-weg-600">Re Order</Link>
                                    <div className="content-header text-mgrey font-size-12">Choose from {this.state.LASTORDER} item{this.state.LASTORDER>1?'s':''}</div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="card pt-1 pb-1 text-center">
                                    <Link to="/special-offers" className="text-upper mb-05 font-size-12 text-danger font-weg-600">OFFERS</Link>
                                    <div className="content-header text-mgrey font-size-12">Get Best Deals</div>
                                </div>
                            </div>
                        </div>
                    </div>}

                    {/* Categories */}
                    {this.state.CATEGORY.length>0 && <HomeCategory categories={this.state.CATEGORY} />}

                    {/* HOME MANAGER */}
                    {this.state.HOME_MANAGER.length>0 && <HomeManager home_manager={this.state.HOME_MANAGER} />}

                    {/* Store in Store */}
                    {this.state.STORE.length>0 && <HomeStores stores={this.state.STORE} />}

                    {/* Independent Store */}
                    {console.log(this.state.STORE2)}
                    {this.state.STORE2.length>0 && <HomeStores2 stores={this.state.STORE2} />}

                    {/* reorder / wishlist */}
                    <div className="section inset pt-0 pb-3">
                        <div className="row">
                            <div className="col-12">
                                <div className="card p-2">
                                <h3>Any service / delivery complaints?</h3>
                                <p className="mb-0 text-mgrey font-size-14">Our Customer Care Executive will try to resolve all possible issues you faced</p>
                                <div className="pt-2">
                                    <Link to={logged=='Y'?'/orders':'/login'} className="lt-space1 text-upper btn btn-danger btn-block square btn-md">Click here to start</Link>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="section inset pt-0 pb-3 mb-6">
                        <div className="row">
                            <div className="col-12">
                                <div className="card p-2">
                                    <h3>Need Assistance?</h3>
                                    <p className="mb-0 text-mgrey font-size-14">You can get in touch with us from 9am to 9pm</p>
                                    <div className="pt-2">
                                        <Link to="tel:+917447436811" target="_blank" className="lt-space1 text-upper btn btn-outline-danger font-weg-500 font-size-17 btn-block square btn-md">
                                            <ion-icon className="mt-0" name="call"></ion-icon>
                                             7447436811
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <BottomMenu LOCATION={this.state.LOCATION} />
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
      
export default Home;


// WEBPACK FOOTER //
// ./src/components/Home.js